import styles from '../assets/styles/components/PublicHeader.module.scss';
import { useNavigate } from "react-router-dom";
import { ReactComponent as AiBexLogoLong } from '../assets/icons/ai-bex-logo-long.svg';

const PublicHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleClickMenu = (path: string) => {
    if (path === "demo") {
      alert('無料デモ申込へ遷移');
    } else {
      navigate(`/${path}`);
    }
  };

  return (
    <div className={styles.publicHeaderWrap}>
      <div className={styles.publicHeaderContent}>
        <div className={styles.logoWrap}>
          <AiBexLogoLong className={styles.logo} />
          <div>マーケティング特化AIエージェント</div>
        </div>
        <div className={styles.buttonWrap}>
          <button
            className={styles.whiteBtn}
            onClick={() => handleClickMenu("login")}
          >
            ログイン
          </button>
          <button
            onClick={() => handleClickMenu("demo")}
          >
            無料デモ申込
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicHeader;
